import React from 'react';
import { Box, Grid, List, ListItem, Skeleton, Typography } from '@mui/material';
import { v1 } from 'uuid';
import withGraphQL from 'containers/withGraphQL.hoc';
import useCustomerList from 'hooks/useCustomerList';
import { CustomerListItemAddress, CustomerListItemDOB, CustomerListItemEmail, CustomerListItemName, CustomerListItemPhones } from './CustomerListItem';
import { StyledGridContainer, StyledList, StyledPaper } from './styles';
import CustomerListAlert from './CustomerListAlert';
var CustomerList = function (_a) {
    var customer = _a.customer;
    var _b = useCustomerList(customer), customers = _b.customers, loading = _b.loading;
    return (React.createElement(StyledGridContainer, { container: true, p: 1 },
        React.createElement(Typography, { variant: "h5" },
            React.createElement(Typography, { color: "primary", component: "b", variant: "h5" }, customers.length),
            "\u00A0customers found"),
        React.createElement(Grid, { item: true, component: StyledList }, loading ? (React.createElement(Skeleton, { sx: { alignSelf: 'start' }, width: "100%" },
            React.createElement(ListItem, null))) : ((customers.length &&
            customers.map(function (_a) {
                var firstName = _a.firstName, lastName = _a.lastName, gender = _a.gender, email = _a.email, dateOfBirth = _a.dateOfBirth, address = _a.address, phones = _a.phones;
                return (React.createElement(Box, { key: v1(), component: ListItem, mb: 2, p: 0 },
                    React.createElement(StyledPaper, null,
                        React.createElement(Box, { component: List, p: 1 },
                            React.createElement(CustomerListItemName, { firstName: firstName, gender: gender, lastName: lastName }),
                            React.createElement(CustomerListItemEmail, { email: email }),
                            React.createElement(CustomerListItemDOB, { dateOfBirth: dateOfBirth }),
                            React.createElement(CustomerListItemAddress, { address: address }),
                            React.createElement(CustomerListItemPhones, { phones: phones })))));
            })) ||
            (customer && React.createElement(CustomerListAlert, { customer: customer }))))));
};
export default withGraphQL(CustomerList);
//# sourceMappingURL=CustomerList.js.map